var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRansomware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 21.6666C33.3337 29.9999 27.5003 34.1666 20.567 36.5833C20.2039 36.7063 19.8096 36.7004 19.4503 36.5666C12.5003 34.1666 6.66699 29.9999 6.66699 21.6666V9.99994C6.66699 9.55791 6.84259 9.13399 7.15515 8.82142C7.46771 8.50886 7.89163 8.33327 8.33366 8.33327C11.667 8.33327 15.8337 6.33327 18.7337 3.79994C19.0867 3.49827 19.5359 3.33252 20.0003 3.33252C20.4647 3.33252 20.9139 3.49827 21.267 3.79994C24.1837 6.34994 28.3337 8.33327 31.667 8.33327C32.109 8.33327 32.5329 8.50886 32.8455 8.82142C33.1581 9.13399 33.3337 9.55791 33.3337 9.99994V21.6666Z",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L18.3333 23.3333L25 16.6666",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRansomware);
export default __webpack_public_path__ + "static/media/icon-ransomware.1374b72c11da383bc67b5260b59e6e92.svg";
export { ForwardRef as ReactComponent };